import React from "react";
import Menu from "../pages/components/menu";
import ProfileInfo from "../pages/components/profile-info";
import DashboardShell from "./DashboardShell";
import { AppTopBar } from "./AppTopBar";
import { useMenuState } from "../Common/MenuStateContext";
import { ClientPageIntro } from "./client/ClientPageIntro";
import "../styles/client-page.css";

export type ClientPageIntroConfig = {
  eyebrow?: string;
  /** Large card headline; defaults to the shell page title */
  heading?: string;
  description: React.ReactNode;
};

interface ClientAppShellProps {
  title: string;
  dataNav: string;
  children: React.ReactNode;
  intro?: ClientPageIntroConfig;
  selectedItem?: string | null;
  onMenuSelect?: (item: string) => void;
  profileSlot?: React.ReactNode;
  contentClassName?: string;
  containerClassName?: string;
}

const ClientAppShell: React.FC<ClientAppShellProps> = ({
  title,
  dataNav,
  children,
  intro,
  selectedItem = null,
  onMenuSelect,
  profileSlot,
  contentClassName = "",
  containerClassName = "",
}) => {
  const { isMenuCollapsed, toggleMenuCollapse } = useMenuState();

  return (
    <DashboardShell
      containerClassName={containerClassName}
      isMenuCollapsed={isMenuCollapsed}
      hideTopBarLead
      sidebar={
        <Menu
          onSelect={onMenuSelect}
          selectedItem={selectedItem}
          isCollapsed={isMenuCollapsed}
          onToggleCollapse={toggleMenuCollapse}
        />
      }
    >
      <AppTopBar
        title={title}
        dataNav={dataNav}
        actions={profileSlot ?? <ProfileInfo />}
      />

      <main className={`app-content${contentClassName ? ` ${contentClassName}` : ""}`}>
        <div className="app-content__surface">
          <div className="client-page">
            {intro ? (
              <ClientPageIntro
                pageTitle={title}
                heading={intro.heading}
                eyebrow={intro.eyebrow}
                description={intro.description}
              />
            ) : null}
            <div className="client-page__body">{children}</div>
          </div>
        </div>
      </main>
    </DashboardShell>
  );
};

export default ClientAppShell;
